import * as React from 'react'
const PlusInBoxSVG = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 25'
    width={props.width}
    height={props.width + 1}
    preserveAspectRatio='xMinYMin meet'
    fill='none'
    {...props}
  >
    <path
      fill={props.fill}
      d='M16.19 2.5H7.81C4.17 2.5 2 4.67 2 8.31v8.37c0 3.65 2.17 5.82 5.81 5.82h8.37c3.64 0 5.81-2.17 5.81-5.81V8.31c.01-3.64-2.16-5.81-5.8-5.81Z'
      opacity={0.4}
    />
    <path
      fill={props.fill}
      d='M16 11.75h-3.25V8.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.25H8c-.41 0-.75.34-.75.75s.34.75.75.75h3.25v3.25c0 .41.34.75.75.75s.75-.34.75-.75v-3.25H16c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z'
    />
  </svg>
)
export default PlusInBoxSVG
